
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import OrderSearch from '../orderServicer/components/OrderSearchCustom.vue';
import OrderList from '../orderServicer/components/OrderList.vue';

import { ViewType, OrderServiceStage } from '@/types/orderServicer';

@Component({
  name: 'CustomerRelatedOrder',
  components: {
    OrderSearch,
    OrderList
  }
})

export default class extends Vue {
private stage = OrderServiceStage.SERVICE_STAGE;
  private vt = ViewType.ORDER_SERVICER_CUSTOMER_ORDER;
}
